/* tslint:disable */
/* eslint-disable */
// @ts-ignore
import * as Types from '../../../../../global-graphql-types'

import { DocumentNode } from 'graphql'
import * as Apollo from '@apollo/client'
import * as ApolloReactHooks from 'utils/extendApolloHooks'
const defaultOptions = {} as const
export type CartAddItemVariables = Types.Exact<{
  cartUuid: Types.Scalars['String']
  item: Types.CartItemInput
}>

export type CartAddItem = {
  __typename: 'Root'
  cartAddItem: {
    __typename: 'CartAddItemPayload'
    cart: { __typename: 'Cart'; id: number | null } | null
    errors: Array<{
      __typename: 'UserError'
      fullMessage: string | null
      key: string | null
      message: string | null
    }> | null
  } | null
}

export const CartAddItemDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CartAddItem' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'cartUuid' }
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'item' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CartItemInput' }
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cartAddItem' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'cartUuid' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'cartUuid' }
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'item' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'item' }
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cart' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'errors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fullMessage' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode
export type CartAddItemMutationFn = Apollo.MutationFunction<
  CartAddItem,
  CartAddItemVariables
>

/**
 * __useCartAddItem__
 *
 * To run a mutation, you first call `useCartAddItem` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCartAddItem` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cartAddItem, { data, loading, error }] = useCartAddItem({
 *   variables: {
 *      cartUuid: // value for 'cartUuid'
 *      item: // value for 'item'
 *   },
 * });
 */
export function useCartAddItem(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CartAddItem,
    CartAddItemVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<CartAddItem, CartAddItemVariables>(
    CartAddItemDocument,
    options
  )
}
export type CartAddItemHookResult = ReturnType<typeof useCartAddItem>
export type CartAddItemMutationResult = Apollo.MutationResult<CartAddItem>
export type CartAddItemMutationOptions = Apollo.BaseMutationOptions<
  CartAddItem,
  CartAddItemVariables
>
